import React from 'react'
import AboutUs from '../about-us'

const AboutUsNl = () => {
    return <AboutUs languageCode="nl" />
}

export default AboutUsNl
